const store = {
    namespaced: true,
    state() {
        return {
            opened: [],
            modalsNames: {
                DELETE: 'delete',
                DRAFT_SAVE: 'draftSave',
                TOOLS_ANNOUNCEMENTS: 'toolsAnnouncements',
                USER_DATA_MOBILE: 'userDataMobile',
                FILTER_ANNOUNCEMENTS: 'filtersAnnouncements',
                REPORT_USER: 'reportUser',
                POST_SHARE: 'postShare',
                REPORT_USER_SUCCESS: 'reportUserSuccess',
                ADD_ANNOUNCEMENT_SUCCESS: 'addAnnouncementSuccess',
                SORTING_ANNOUNCEMENTS: 'sortingAnnouncements',
                ANNOUNCEMENTS_LAYOUT: 'announcementsLayout',
            }
        }
    },
    getters: {
        lastActive: (state) => (state.opened.length > 0 ? state.opened[0] : null),
        opened: (state) => state.opened,
        modalsNames: (state) => state.modalsNames,
    },
    mutations: {
        OPEN: (state, name) => state.opened.unshift(name),
        CLOSE: (state, name) => state.opened = state.opened.filter((el) => el !== name),
        CLOSE_OTHER: (state, name) => state.opened = state.opened.filter((el) => el === name),
        CLOSE_ALL: (state) => state.opened = []
    },
    actions: {
        open: ({ commit }, name) => {
            commit('CLOSE_ALL')
            commit('OPEN', name)
        },
        close: ({ commit }, name) => commit('CLOSE', name),
        closeOther: ({ commit }, name) => commit('CLOSE_OTHER', name),
        closeAll: ({ commit }) => commit('CLOSE_ALL')
    }
}

export default store